module.exports = __webpack_public_path__ + "vi.svg?2127440f728f099608ed690b93661341";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/vi.svg
// module id = 1688
// module chunks = 0